import React from "react";
import { DateInput, DateInputProps } from "@mantine/dates";

export function EDateInput({ ...props }: DateInputProps) {
  return (
    <DateInput
      radius="md"
      size="md"
      labelProps={{ className: "mb-1 text-sm", style: { fontSize: "14px" } }}
      {...props}
      value={props.value ? props.value : null}
    />
  );
}
